import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=3a30f032&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"
import style0 from "./Shell.vue?vue&type=style&index=0&id=3a30f032&prod&lang=less&scoped=true"
import style1 from "./Shell.vue?vue&type=style&index=1&id=3a30f032&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_5a36e3d9a1016b548fda15b2542a0eed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a30f032",
  null
  
)

export default component.exports